export default __webpack_public_path__ + "static/media/no_search@2x.44c2a570.png";